var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.data.isPaid)?_c('span',[_vm._v(_vm._s(_vm.label))]):_c('span',{staticClass:"FeeChip_free"},[_vm._v("Free")])])
}
var staticRenderFns = []

export { render, staticRenderFns }